import React from 'react';
import { Link } from 'react-router-dom';
import cs from 'classnames';
import PropTypes from 'prop-types';

import './btn.css';

const Button = (props) => {
	const { color, children, className, ...rest } = props;

	const classes = cs(
		className ? className : false,
		'btn',
		color ? `btn--${color}` : false
	);

	if (rest.to) {
		return (
			<Link className={classes} {...rest}>
				{children}
			</Link>
		)
	} 

	if (rest.href) {
		return (
			<a className={classes} {...rest}>
				{children}
			</a>
		)
	}

	return (
		<button className={classes} {...rest}>
			{children}
		</button>
	);
};

Button.propTypes = {
	color: PropTypes.oneOf([
		'default', 
		'primary', 
		'secondary',
		'icon',
	]).isRequired,
}

Button.defaultProps = {
	color: "default"
}

export default Button;


// WEBPACK FOOTER //
// ./src/components/common/form/Button/index.js